import React from 'react';
import { connect } from 'react-redux';
// actions
import { getPowers } from '../../../actionCreators/editPower';
// components
import { Form } from 'react-final-form';
import ItemInfo from './ItemInfo';
import { PowerInputs, getPrescription, getDirtyValues } from './PowerInputs';

class ContactLens extends React.PureComponent {
    constructor(props) {
        super(props);
        const { item } = this.props;
        const { prescription = {} } = item || {};
        let pristine = {};
        if (prescription.left && prescription.right) {
            pristine = getPrescription(prescription);
        } else if (prescription.left) {
            pristine = getPrescription(prescription, 'left');
        } else if (prescription.right) {
            pristine = getPrescription(prescription, 'right');
        }
        this.state = {
            pristine
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        const { getPowers, item } = this.props;
        const { productId } = item || {};
        if (productId) {
            getPowers({ productId });
        }
    }

    componentDidUpdate(prevProps) {
        const { item } = this.props;
        if (prevProps.item !== item && item) {
            const { prescription = {} } = item;
            let pristine = {};
            if (prescription.left && prescription.right) {
                pristine = getPrescription(prescription);
            } else if (prescription.left) {
                pristine = getPrescription(prescription, 'left');
            } else if (prescription.right) {
                pristine = getPrescription(prescription, 'right');
            }
            (() => { this.setState({ pristine }); })();
        }
    }

    submit(values) {
        this.dirtyValues = getDirtyValues(this.state.pristine, values);
        const { submitCallback, powers, item } = this.props;
        const submitValues = [];
        if (this.dirtyValues) {
            Object.keys(this.dirtyValues).reduce((memo, key) => {
                const val = key.split('-');
                const type = val[0];
                const eyeLR = val[1];
                powers.reduce((memo, power) => {
                    if (power.type === type) {
                        memo.push({ type, eyeLR, name: key, label: `${eyeLR} ${power.label}`, value: this.dirtyValues[key]});
                    }
                    return memo;
                }, memo);
                return memo;
            }, submitValues);
        }
        submitCallback(submitValues, item);
    }

    render() {
        const { powerSubmitted, powerSubmittedItemId, item, powers = [], dataLocale } = this.props;
        const { name, productId, prescription = {} } = item || {};
        const hasSingleEye = !(prescription.left && prescription.right);
        let whichEye;
        if (hasSingleEye) {
            whichEye = prescription.left ? 'left' : 'right';
        }
        const { SUBMIT, POWER_DETAILS_UPDATED_SUCCESSFULLY, POWER_DETAILS_UPDATED_FAILED } = dataLocale;
        return (
            <React.Fragment>
                <ItemInfo name={name} productId={productId} dataLocale={dataLocale} />
                <Form
                    initialValues={this.state.pristine}
                    onSubmit={this.submit}
                >
                    {({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <div><PowerInputs powers={powers} whichEye={whichEye} dataLocale={dataLocale} /></div>
                            {powerSubmittedItemId && item.id === powerSubmittedItemId && <div className={`margin-t10 margin-b10 fw700 fs14${powerSubmitted ? ' success-msg' : ' error-msg'}`}>{powerSubmitted ? POWER_DETAILS_UPDATED_SUCCESSFULLY : POWER_DETAILS_UPDATED_FAILED}</div>}
                            <div className="submit-button margin-b20 margin-t15">
                                <button className="form-SLA_field-row_submit bora-2 fs16 fw700 text-capitalize" type="submit" style={{ width: '200px' }}>{SUBMIT}</button>
                            </div>
                        </form>
                    )}
                </Form>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { productId: pid } = ownProps.item || {};
    const powers = state.editPower.pidToPowers ? state.editPower.pidToPowers[pid] : undefined;
    return {
        powers,
        powerSubmittedItemId: state.success.powerSubmittedItemId,
        powerSubmitted: state.success.powerSubmitted,
        dataLocale: state.locale
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPowers: data => dispatch(getPowers(data))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactLens);
